
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"#FF4646","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M20.25 23.25a1.934 1.934 0 00-.75-1.572 11.239 11.239 0 00-7.5-2.357 11.239 11.239 0 00-7.5 2.357 1.934 1.934 0 00-.75 1.572"}}),_c('path',{attrs:{"d":"M10.5 23.071l1.5-3.75 1.5 3.75M18 6.75a6 6 0 10-12 0 5.846 5.846 0 003.429 5.493V15h5.142v-2.757A5.846 5.846 0 0018 6.75zM12 15v1.5M8.938 12h6.124M12 12V9"}}),_c('path',{attrs:{"d":"M14.25 6.75L12 9 9.75 6.75m12 0h1.5m-1.811 3.439L22.5 11.25m-1.061-7.94L22.5 2.25M2.25 6.75H.75m1.811 3.439L1.5 11.25m1.061-7.94L1.5 2.25"}})])])
          )
        }
      }
    